// import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';

export const selectDialogName = (state:RootState) => state[Reducers.AppUIDialog].dialogName;
export const selectDialogProps = (state:RootState) => state[Reducers.AppUIDialog].dialogProps;
